export enum SaveAsBatchColumnTypes {
  CHECKBOX = 'checkbox',
  TEXT = 'text',
  DELIVERY_PROMISE = 'delivery-promise',
  ORDER_NUMBER = 'order-number',
  DROPWOWN_MENU = 'dropdown-menu',
  SKU = 'sku',
}

export enum SaveAsBatchEventNames {
  DETACH_ORDER = 'detach_order',
}

export enum SmartBatchColumnsProps {
  DELIVERY_PROMISE_STATUS = 'deliveryTimePredictionStatus',
  ESTIMATED_DELIVERY_DATE = 'etaFromPickupPrint',
  ESTIMATED_SHIPMENT_COST = 'ratePrice',
  CHARGED_FOR_SHIPPING = 'orderShipmentFee',
  BOX_NAME = 'boxName',
  BOX_SIZE = 'boxSize',
  BOXES_OPTIONS = 'sizeOptions',
  SERVICE_LEVEL_NAME = 'serviceLevelName',
  SERVICE_LEVEL_OPTIONS = 'serviceLevelOptions',
  ORDER_NUMBER = 'orderNumber',
  ITEM_COUNT = 'itemCount',
  SKU = 'skus',
  STATE = 'province',
}

export const DROPDOWN_OPTIONS_FIELD = 'dropdownOptionsProp';

export interface SaveAsBatchColumnSettings {
  type: SaveAsBatchColumnTypes;
  name: string;
  prop: string; // check this
  propTitle?: string;
  secondaryProp?: string;
  valueProp?: string;
  hideColumnName?: boolean;
  sortable?: boolean;
  width: number;
  minWidth?: number;
  maxWidth?: number;
  [DROPDOWN_OPTIONS_FIELD]?: string;
  sortDirection?: string;
  buttonIconSrc?: string;
  buttonEventName?: SaveAsBatchEventNames;
  displayCondition?: (shopMetadata?: any) => boolean;
}

export interface DropdownOption {
  value: any;
  mainText: string;
  secondaryText?: string;
  provider?: string;
}

export const columnsConfigs: SaveAsBatchColumnSettings[] = [
  {
    type: SaveAsBatchColumnTypes.CHECKBOX,
    name: 'checkbox',
    prop: 'checkbox', // check this
    hideColumnName: true,
    sortable: false,
    width: 50,
    minWidth: 50,
    maxWidth: 50,
  },
  {
    type: SaveAsBatchColumnTypes.ORDER_NUMBER,
    sortable: true,
    prop: SmartBatchColumnsProps.ORDER_NUMBER,
    name: 'Order no.', // check this
    width: 70,
    minWidth: 70,
    buttonIconSrc: '/assets/icons/icon-back.svg',
    buttonEventName: SaveAsBatchEventNames.DETACH_ORDER,
  },
  {
    type: SaveAsBatchColumnTypes.TEXT,
    sortable: true,
    prop: SmartBatchColumnsProps.ITEM_COUNT,
    name: 'Items',
    width: 20,
    minWidth: 20,
    displayCondition: (metadata) => {
      return !!metadata?.displayQuantityAndSkuColumnsInSmartBatch;
    },
  },
  {
    type: SaveAsBatchColumnTypes.SKU,
    sortable: true,
    prop: SmartBatchColumnsProps.SKU,
    name: 'SKUs',
    width: 50,
    minWidth: 50,
    displayCondition: (metadata) => {
      return !!metadata?.displayQuantityAndSkuColumnsInSmartBatch;
    },
  },
  {
    type: SaveAsBatchColumnTypes.TEXT,
    sortable: true,
    prop: SmartBatchColumnsProps.STATE,
    name: 'State',
    width: 50,
    minWidth: 50,
    displayCondition: (metadata) => {
      return !!metadata?.displayStateColumnInSmartBatch;
    },
  },
  {
    type: SaveAsBatchColumnTypes.DROPWOWN_MENU,
    sortable: true,
    dropdownOptionsProp: SmartBatchColumnsProps.SERVICE_LEVEL_OPTIONS,
    prop: SmartBatchColumnsProps.SERVICE_LEVEL_NAME,
    name: 'Service level selected',
    width: 70,
    minWidth: 70,
  },
  {
    type: SaveAsBatchColumnTypes.DROPWOWN_MENU,
    sortable: true,
    prop: SmartBatchColumnsProps.BOX_NAME,
    secondaryProp: SmartBatchColumnsProps.BOX_SIZE,
    valueProp: 'boxId',
    dropdownOptionsProp: SmartBatchColumnsProps.BOXES_OPTIONS,
    name: 'Package dimensions',
    width: 70,
    minWidth: 70,
  },
  {
    type: SaveAsBatchColumnTypes.TEXT,
    sortable: true,
    prop: SmartBatchColumnsProps.CHARGED_FOR_SHIPPING,
    name: 'Charged for shipping',
    width: 70,
    minWidth: 70,
  },
  {
    type: SaveAsBatchColumnTypes.TEXT,
    sortable: true,
    prop: SmartBatchColumnsProps.ESTIMATED_SHIPMENT_COST,
    name: 'Est. shipment cost',
    width: 70,
    minWidth: 70,
  },
  {
    type: SaveAsBatchColumnTypes.TEXT,
    sortable: true,
    prop: SmartBatchColumnsProps.ESTIMATED_DELIVERY_DATE,
    propTitle: 'estimationRateDeliveryDateStr',
    name: 'Est. Delivery date',
    width: 70,
    minWidth: 70,
  },
  {
    type: SaveAsBatchColumnTypes.DELIVERY_PROMISE,
    sortable: true,
    prop: SmartBatchColumnsProps.DELIVERY_PROMISE_STATUS,
    name: 'Delivery promise',
    width: 110,
    minWidth: 130,
    maxWidth: 260,
  },
];
